import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import {
	AutocompleteInput,
	BulkActionProps,
	BulkDeleteButton,
	DateInput,
	List,
	ListProps,
	ReferenceInput,
	TextInput
} from 'react-admin';
import { CoachGuideList } from './CoachGuideList';
import { CoachGuideDatagrid } from './CoachGuideDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { CoachGuide } from './CoachGuide';

export * from './CoachGuide';
export * from './CoachGuideCreate';
export * from './CoachGuideDatagrid';
export * from './CoachGuideEdit';
export * from './CoachGuideList';
export * from './CoachGuideShow';

const CoachGuidesBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'imageUrl', header: 'Image' },
	{ key: 'title', header: 'Title' },
	{ key: 'price', header: 'Price' },
	{ key: 'description', header: 'Description' },
	{ key: 'category.name', header: 'Category' },
	{ key: 'organization.name', header: 'Organization' }
];

export const CoachGuidesData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: CoachGuide) => entity;

	const coachGuidesFilter = [
		<TextInput source="title" alwaysOn label="SEARCH"/>,
		<ReferenceInput
			step={1}
			label="CATEGORY"
			source="categoryId" reference="coach-guide-categories"
			alwaysOn
		>
			<AutocompleteInput optionText="name"/>
		</ReferenceInput>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('מתכונים', exportFields, exportDataMapper)}
				{...props}
				filters={coachGuidesFilter}
				bulkActionButtons={<CoachGuidesBulkActionButtons/>}
				title="COACH_GUIDES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <CoachGuideList/> : <CoachGuideDatagrid/>}
			</List>
		</Fragment>
	);
};
